/**
 * App route paths. Link targets use these instead of string literals.
 *
 * `/sessions` stays the Vođene (guided) list so existing links and bookmarks keep working.
 */
import type { DurationBucket } from '@/utils/sessionBrowse';

export const ROUTES = {
  home: '/',
  acoustic: '/acoustic',
  guided: '/sessions',
  journal: '/journal',
  favorites: '/favorites',
  subscription: '/pricing',
  paymentSuccess: '/success',
  profile: '/profile',
  history: '/history',
  pendulum: '/pendulum',
  chakra: '/chakra',
  login: '/login',
  register: '/register',
  /** The in-app book (ebook-plan § 3.13): overview, the reader for one chapter, and the purchase return (§ 3.9). */
  book: '/book',
  bookRead: '/book/read/:chapterId',
  bookSuccess: '/book/success',
  bookChapter: (chapterId: string, blockId?: string | null): string =>
    `/book/read/${encodeURIComponent(chapterId)}${blockId ? `?block=${encodeURIComponent(blockId)}` : ''}`,
  sessionDetail: (sessionId: string): string => `/sessions/${encodeURIComponent(sessionId)}`,
  /** Vođene, one category in full ("Prikaži sve"); `groupKey` is a session group key. */
  guidedCategory: (groupKey: string): string => `/sessions?category=${encodeURIComponent(groupKey)}`,
  /** Vođene with a duration filter on, e.g. SOS for Početna's "Kratka pauza za sebe" → "Prikaži sve". */
  guidedDuration: (bucket: DurationBucket): string => `/sessions?duration=${bucket}`,
} as const;
